// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide-page {
  background: var(--bg-primary);
  padding-top: 50px;
  transition: background-color 0.3s ease;
}

.guide-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem 1.5rem 3rem;
}

.guide-back {
  margin-bottom: 1rem;
}

.guide-back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.8rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  border: 1px solid var(--border-primary);
  transition: all 0.2s ease;
}

.guide-back-link:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
}

.guide-title {
  font-size: 2rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 1.5rem;
  font-family: 'Inter', sans-serif;
}

.guide-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.guide-section {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 1.5rem;
}

.guide-section h2 {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.75rem;
}

.guide-section h3 {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 1rem 0 0.5rem;
}

.guide-section h3:first-of-type {
  margin-top: 0.5rem;
}

.guide-section h4.guide-h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 1rem 0 0.5rem;
}

.guide-timezone-preview {
  background: var(--bg-primary);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 0.5rem;
  border: 1px solid var(--border-primary);
}

.guide-timezone-preview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.35rem 0;
  gap: 1rem;
}

.guide-timezone-preview-label {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.guide-timezone-preview-value {
  font-family: ui-monospace, monospace;
  font-size: 1rem;
  padding: 0.2rem 0.5rem;
  background: var(--bg-secondary);
  border-radius: 4px;
  color: var(--text-primary);
}

.guide-optional-hint {
  font-size: 0.9rem;
  color: var(--text-tertiary);
  font-style: italic;
  margin-bottom: 0.75rem;
}

.guide-section p {
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0 0 0.5rem;
}

.guide-section p:last-child {
  margin-bottom: 0;
}

.guide-subsection {
  margin-top: 1rem;
}

.guide-subsection h3 {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
}

.guide-steps {
  list-style: none;
  padding: 0;
  margin: 0;
  counter-reset: step;
}

.guide-steps li {
  counter-increment: step;
  padding: 0.75rem 1rem 0.75rem 3rem;
  margin-bottom: 0.5rem;
  background: var(--bg-primary);
  border-radius: 8px;
  color: var(--text-primary);
  position: relative;
  line-height: 1.5;
}

.guide-steps li::before {
  content: counter(step);
  position: absolute;
  left: 0.75rem;
  top: 0.75rem;
  width: 1.5rem;
  height: 1.5rem;
  background: var(--accent-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
}

.guide-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.guide-list li {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.4rem;
  background: var(--bg-primary);
  border-radius: 6px;
  border-left: 3px solid var(--accent-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  line-height: 1.5;
}

.guide-note {
  font-style: italic;
  color: var(--text-tertiary);
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

.guide-inline-link {
  color: var(--accent-primary);
  text-decoration: underline;
  font-weight: 500;
}

.guide-inline-link:hover {
  color: var(--accent-hover);
}

/* Scroll-spy content sections in guides */
.guide-page .content-section {
  scroll-margin-top: 140px;
}

@media (max-width: 680px) {
  .guide-container {
    padding: 0.75rem 1rem 2rem;
  }

  .guide-title {
    font-size: 1.5rem;
  }

  .guide-section {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/guides/GuidePage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;EAC5C,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".guide-page {\n  background: var(--bg-primary);\n  padding-top: 50px;\n  transition: background-color 0.3s ease;\n}\n\n.guide-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 1rem 1.5rem 3rem;\n}\n\n.guide-back {\n  margin-bottom: 1rem;\n}\n\n.guide-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.4rem 0.8rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  border: 1px solid var(--border-primary);\n  transition: all 0.2s ease;\n}\n\n.guide-back-link:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n}\n\n.guide-title {\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 1.5rem;\n  font-family: 'Inter', sans-serif;\n}\n\n.guide-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.guide-section {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.guide-section h2 {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 0.75rem;\n}\n\n.guide-section h3 {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 1rem 0 0.5rem;\n}\n\n.guide-section h3:first-of-type {\n  margin-top: 0.5rem;\n}\n\n.guide-section h4.guide-h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 1rem 0 0.5rem;\n}\n\n.guide-timezone-preview {\n  background: var(--bg-primary);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 0.5rem;\n  border: 1px solid var(--border-primary);\n}\n\n.guide-timezone-preview-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.35rem 0;\n  gap: 1rem;\n}\n\n.guide-timezone-preview-label {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.guide-timezone-preview-value {\n  font-family: ui-monospace, monospace;\n  font-size: 1rem;\n  padding: 0.2rem 0.5rem;\n  background: var(--bg-secondary);\n  border-radius: 4px;\n  color: var(--text-primary);\n}\n\n.guide-optional-hint {\n  font-size: 0.9rem;\n  color: var(--text-tertiary);\n  font-style: italic;\n  margin-bottom: 0.75rem;\n}\n\n.guide-section p {\n  color: var(--text-secondary);\n  line-height: 1.7;\n  margin: 0 0 0.5rem;\n}\n\n.guide-section p:last-child {\n  margin-bottom: 0;\n}\n\n.guide-subsection {\n  margin-top: 1rem;\n}\n\n.guide-subsection h3 {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem;\n}\n\n.guide-steps {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  counter-reset: step;\n}\n\n.guide-steps li {\n  counter-increment: step;\n  padding: 0.75rem 1rem 0.75rem 3rem;\n  margin-bottom: 0.5rem;\n  background: var(--bg-primary);\n  border-radius: 8px;\n  color: var(--text-primary);\n  position: relative;\n  line-height: 1.5;\n}\n\n.guide-steps li::before {\n  content: counter(step);\n  position: absolute;\n  left: 0.75rem;\n  top: 0.75rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  background: var(--accent-primary);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.guide-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.guide-list li {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0.4rem;\n  background: var(--bg-primary);\n  border-radius: 6px;\n  border-left: 3px solid var(--accent-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.guide-note {\n  font-style: italic;\n  color: var(--text-tertiary);\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n}\n\n.guide-inline-link {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.guide-inline-link:hover {\n  color: var(--accent-hover);\n}\n\n/* Scroll-spy content sections in guides */\n.guide-page .content-section {\n  scroll-margin-top: 140px;\n}\n\n@media (max-width: 680px) {\n  .guide-container {\n    padding: 0.75rem 1rem 2rem;\n  }\n\n  .guide-title {\n    font-size: 1.5rem;\n  }\n\n  .guide-section {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
